<template>
   <div class="pricing-info-container">
      <PageHeader :title="$t('pages.pricing.info.title')" :desc="$t('pages.pricing.info.text')">
         <DownloadButton>{{$t('pages.pricing.info.downloadButtonDesc')}}</DownloadButton>
      </PageHeader>
      <PageFrameContainer>
         <PricingPlansCardViewSection/>
         <PricingFaqAndContactSection/>
         <PricingPlansCompareTableSection/>
      </PageFrameContainer>
   </div>
</template>

<script>
    import PageFrameContainer from "../../components/PageFrameContainer";
    import DownloadButton from "../../components/DownloadButton";
    import PricingPlansCardViewSection from "./sections/PricingPlansCardViewSection";
    import PricingPlansCompareTableSection from "./sections/PricingPlansCompareTableSection";
    import PageHeader from "../../components/PageHeader";
    import PricingFaqAndContactSection from "./sections/PricingFaqAndContactSection";

    export default {
        name: "Pricing",
        components: {
            PricingFaqAndContactSection,
            PageHeader,
            PricingPlansCompareTableSection,
            PricingPlansCardViewSection,
            DownloadButton, PageFrameContainer
        }
    }
</script>

<style scoped lang="scss">
   @import "../../theme/theme";

   .pricing-info-container {
      display: grid;
      margin-left: auto;
      margin-right: auto;
      grid-auto-flow: row;
      text-align:justify;
   }

</style>